import { api } from "@/api";
import type { UUID } from "@/core/types";

/** We want to explicitly opt-out from the default loading spinner to show skeletons and do optimistic updates */
const params = {
  showLoader: false,
};

export async function getPatientConsents(patientId: UUID) {
  return api.providerTyped.get_patient_consents({ params, patientId });
}
